import React, { useEffect, useState } from 'react'
import { ActivityIndicator, Platform } from 'react-native'

import { i18n } from '@localization'
import { useRoute } from '@react-navigation/native'
import { publishEvent } from '@zet/analytics'
import { BottomSheet, H5, Stack } from '@zet/design-system'
import { LoggedInNavigation } from '@zet/utils/interface'

import { useNavigation } from '@hooks/useNavigation'

import { useMissingFields } from '../../api/missingFieldsPopup/hooks'
import { FormBuilder } from './form/form-builder'

const MissingFieldsPopup = () => {
  const { params, name } = useRoute()
  const navigation = useNavigation<LoggedInNavigation>()
  const { data, isLoading } = useMissingFields(
    params?.brandId,
    params?.customerId
  )

  const [isSheetVisible, setIsSheetVisible] = useState(true)

  const [fields, setFields] = useState([])
  const missingFields = data?.missingFields
  const result = missingFields?.map((item) => item.code)

  const fieldValues = data?.values
  const validationSchema = data?.validationSchema || {}

  useEffect(() => {
    getFieldsList()
  }, [missingFields])

  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: Platform.OS === 'web' ? name : 'missing-details',
      brand_name: params?.brandName,
      partner_id: params?.brandId,
      customer_id: params?.customerId,
      customer_name: params?.customerName,
      customer_phone_number: params?.customerPhoneNumber,
    })
  }, [])

  const getFieldsList = () => {
    const missedFieldsArr = []
    missingFields?.forEach?.((item) => {
      if (item?.code !== undefined) {
        const getMissingFields = data?.formFields.filter(
          (d) => d.code === item.code
        )
        missedFieldsArr.push(getMissingFields[0])
      }
    })

    setFields(missedFieldsArr)
  }

  const ocFields = fields?.sort(function (a, b) {
    return result?.indexOf(b.code) - result.indexOf(a.code)
  })

  const closeSheet = () => {
    setIsSheetVisible(false)
    navigation?.goBack()
  }

  if (isLoading) {
    return (
      <Stack className="bg-grays-40 flex-1 justify-center">
        <ActivityIndicator size={'large'} color={'blue'} />
      </Stack>
    )
  }

  return (
    <Stack className="bg-grays-40 flex-1">
      <BottomSheet
        visible={isSheetVisible}
        disableBottomSheet={closeSheet}
        onDismiss={closeSheet}
        sheetName="missing_fields_details_required"
      >
        <Stack className="pt-3">
          <H5 className="mx-4">
            {i18n.t('missingFieldsPopup.detailsRequired')}
          </H5>
          <FormBuilder
            ocFields={ocFields}
            fieldValues={fieldValues}
            validationSchema={validationSchema}
            customerId={params?.customerId}
            generateLinkParams={params?.generateLinkParams}
            brandId={params?.brandId}
            customerName={params?.customerName}
            brandName={params?.brandName}
            customerPhoneNumber={params?.customerPhoneNumber}
            leadSource={params?.leadSource}
          />
        </Stack>
      </BottomSheet>
    </Stack>
  )
}

export default MissingFieldsPopup
